import { motion } from "framer-motion";

// Compact static-ish graph used inside cognitive link cards
export const MiniGraph = ({ nodes, edges, width = 260, height = 120 }) => {
  const nodeById = Object.fromEntries(nodes.map((n) => [n.id, n]));
  return (
    <svg
      width="100%"
      viewBox={`0 0 ${width} ${height}`}
      className="overflow-visible"
      aria-hidden="true"
    >
      {edges.map(([a, b], i) => {
        const na = nodeById[a];
        const nb = nodeById[b];
        return (
          <motion.line
            key={i}
            x1={na.x}
            y1={na.y}
            x2={nb.x}
            y2={nb.y}
            stroke="#1E6FFF"
            strokeWidth="1.4"
            strokeOpacity="0.6"
            initial={{ pathLength: 0, opacity: 0 }}
            whileInView={{ pathLength: 1, opacity: 0.6 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9, delay: i * 0.1 }}
          />
        );
      })}
      {nodes.map((n, i) => (
        <g key={n.id}>
          {n.active && (
            <motion.circle
              cx={n.x}
              cy={n.y}
              r="4"
              fill="#4BE3FF"
              initial={{ scale: 0.6, opacity: 0.7 }}
              animate={{ scale: [1, 2.2, 1], opacity: [0.5, 0, 0.5] }}
              transition={{ duration: 2.4, repeat: Infinity, delay: i * 0.3 }}
              style={{ transformOrigin: `${n.x}px ${n.y}px` }}
            />
          )}
          <motion.circle
            cx={n.x}
            cy={n.y}
            r="4"
            fill={n.active ? "#4BE3FF" : "#A7B4C2"}
            initial={{ scale: 0 }}
            whileInView={{ scale: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.3 + i * 0.08, type: "spring", stiffness: 260 }}
          />
          <text
            x={n.x}
            y={n.y - 9}
            textAnchor="middle"
            className="font-mono"
            fontSize="7"
            fill="#A7B4C2"
          >
            {n.label}
          </text>
        </g>
      ))}
    </svg>
  );
};
